<template>
  <div class="content-ct">
    <el-row>
      <el-col :xs="9" :sm="9" :md="8" :lg="6">
        <game-campaign-content-nav
          :menu-items="analyticsNavigation"
          :default-active="activeItemTitle"
          @update="setActiveItem"
        />
      </el-col>
      <el-col :xs="15" :sm="15" :md="16" :lg="18">
        <component
          v-if="activeItem"
          :is="activeItem.component"
          :game-campaign-id="gameCampaignId"
          :is-read-only="isReadOnly"
          @check="$emit('check', $event)"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import GamePlayHistorySubStep from '@/modules/gamification/components/games-campaigns/analytics/GamePlayHistorySubStep.vue'
import GameFixturesSubStep from '@/modules/gamification/components/games-campaigns/analytics/GameFixturesSubStep.vue'
import GameCampaignContentNav from '@/modules/gamification/components/games-campaigns/GameCampaignContentNav.vue'
import { GameCreationSubSteps } from '@/modules/gamification/enum/GameCreationStepsEnum.js'
import GameStepPrizesFormDialog from '@/modules/gamification/components/games-campaigns/prizes/GameStepPrizesFormDialog.vue'

export default {
  name: 'GameStepAnalytics',

  components: {
    GameStepPrizesFormDialog,
    GameCampaignContentNav,
    GamePlayHistorySubStep,
    GameFixturesSubStep
  },

  props: {
    currentSubStep: {
      type: String,
      default: GameCreationSubSteps.PLAY_HISTORY
    },
    gameCampaignId: {
      type: Number
    },
    isReadOnly: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      activeItem: null,
      navigation: [
        {
          title: this.$t('Gamification_GameStepAnalytics_PlayHistory'),
          step: GameCreationSubSteps.PLAY_HISTORY,
          component: GamePlayHistorySubStep
        },
        {
          title: this.$t('Gamification_GameStepAnalytics_Fixtures'),
          step: GameCreationSubSteps.FIXTURES,
          component: GameFixturesSubStep
        }
      ]
    }
  },

  computed: {
    analyticsNavigation() {
      return this.navigation
    },
    activeItemTitle() {
      return this.activeItem ? this.activeItem.title : null
    }
  },
  mounted() {
    this.updateNavigation()
  },
  watch: {
    currentSubStep() {
      this.updateNavigation()
    }
  },
  methods: {
    setActiveItem(tab) {
      this.activeItem = tab
    },
    updateNavigation() {
      this.activeItem =
        this.analyticsNavigation.find(
          item => item.step === this.currentSubStep
        ) || this.analyticsNavigation[0]
    }
  }
}
</script>

<style scoped>
.content-ct {
  padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/pages/GameStepAnalytics.vue